import PropTypes from 'prop-types';
import React from 'react';
import { DataValueMap } from 'Helpers/Testing';
import Relationship from 'facet-rest/src/domain/Relationship';
import { navigateToPageInNewTab } from 'Views/Page/Content/Templates';
import useUserContext from 'Context/UserContext';
import { FDSecondaryActionButton } from '@facet-wealth/design';

const DetailsButton = ({
  relationship,
}) => {
  const { isAgent } = useUserContext();

  return (
    <FDSecondaryActionButton
      onClick={() => {
        navigateToPageInNewTab(
          relationship.link('related').url(),
          isAgent,
        );
      }}
      label={relationship.meta('prompt')}
      {...DataValueMap.init('message-scenario-details-button').build()}
    />
  );
};

DetailsButton.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
};

export default DetailsButton;
